export default __webpack_public_path__ + "static/media/backIcon.7b713e4d.svg";